import Modal from '@/components/Modal'
import usePhysicalOrders from '../hooks/usePhysicalOrders'
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from '@mui/material'
import CameraAltIcon from '@mui/icons-material/CameraAlt'

const styles = {
  container: {
    p: 2
  },
  header: {
    mb: 2,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  }
}

const BatchSnapshotModal = () => {
  const { previewBatch, setPreviewBatch } = usePhysicalOrders()
  const hasOpenBatches = previewBatch && previewBatch.length > 0

  return (
    <Modal open={!!previewBatch} onClose={() => setPreviewBatch()}>
      <Box sx={styles.container}>
        <Box sx={styles.header}>
          <CameraAltIcon sx={{ mr: 1 }} />
          <Typography variant="h2" display="inline" fontSize={24}>
            Batch Snapshot
          </Typography>
        </Box>
        {(hasOpenBatches && (
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>SKU</TableCell>
                  <TableCell>Product</TableCell>
                  <TableCell />
                </TableRow>
              </TableHead>
              <TableBody>
                {previewBatch.map((order) => (
                  <TableRow key={order.sku}>
                    <TableCell>{order.sku}</TableCell>
                    <TableCell>{order.product}</TableCell>
                    <TableCell>{order.quantity}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )) || (
          <Typography>
            There are no open orders in the selected batches.
          </Typography>
        )}
      </Box>
    </Modal>
  )
}

export default BatchSnapshotModal
